export default __webpack_public_path__ + "static/media/ubi4.d19457cc.jpg";